<mat-form-field class="search" appearance="fill" [class.has-value]="value">
  <input type="text" matInput [placeholder]="placeholder" [(ngModel)]="value" (keyup)="filter.emit($event)" />
  <button *ngIf="!value" matSuffix mat-icon-button class="input-suffix">
    <i matSuffix class="xos-icon icon-search-grey"></i>
  </button>
  <button *ngIf="value" matSuffix mat-icon-button class="input-suffix" (click)="clearValue()">
    <i class="xos-icon icon-close-circle"></i>
  </button>
</mat-form-field>
